<template>
<div>
    <div class="chartFilter">
        <select class="country_select toUpper" v-if="countryFlag" name="country">
            <option :value="countryList.id">{{countryList.displayName}}</option>
        </select>
        <select class="province_select toUpper" v-if="stateFlag" name="state" v-model="stateId" @change="provinceSelect($event)">
            <option value="">{{ $t("Filter.selectstate") }}</option>
            <option v-for="(items,idx) in stateList" :key="idx" :value="items.id">{{items.name}}</option>
        </select>
        <select class="region_select toUpper" v-if="distFlag" name="district" v-model="distId" @change="districtChange($event)">
            <option value="">{{ $t("Filter.selectdistrict") }}</option>
            <option v-for="(items,idx) in districtList" :key="idx" :value="items.id">{{items.name}}</option>
        </select>
        <!-- Period Filters -->
        <select v-model="periodType" class="year_select">
            <option value="" selected="selected">Period Type</option>
            <option value="Annual">Annual</option>
            <option value="Daily">Daily</option>
        </select>
        <date-picker v-show="periodType == 'Daily'" class="pl-2" @change=getDate value-type='YYYY-MM-DD' v-model="value1" type="date" range placeholder="Select date range"></date-picker>
        <date-picker v-show="periodType == 'Annual'" class="pl-2" @change=getDate value-type='YYYY' v-model="value1" type="year" year placeholder="Select Year"></date-picker>
        <!--  -->
        <select class="toUper" v-model="ageGroup" v-show="this.userData.programid == '1262097'">
            <option selected="selected" value="">Select Age Group</option>
            <option value="<">
                <= 5 Year</option> <option value=">">> 5 Year
            </option>
        </select>
        <select v-model="typeOfClient" class="">
            <option value="">All</option>
            <option selected="selected" value="Contact">Contacts</option>
            <option value="Person living with HIV">People with HIV</option>
            <option value="Others">Others</option>
        </select>
        <!-- <select class="region_select toUpper" name="city" @change="cityChange($event)">
            <option selected="selected" value="">Select Facility</option>
            <option v-for="(items,idx) in facilityList" :key="idx" :value="items.id">{{items.name}}</option>
        </select> -->
        <!-- <select class="year_select">
        <option selected="selected">Start Year</option>
      </select>
      <select class="month_select">
        <option selected="selected">Select Month</option>
      </select>
      <select class="week_select">
        <option selected="selected">Select Week</option>
      </select> -->
        <button class="btn btn-sm btn_apply" @click="triggerFilter()">{{ $t("Filter.apply") }}</button>
    </div>
    <div class="stat_counter" style="z-index: 0;">
        <!-- New row -->
        <div class="row bottomBorder no-gutters" style="border-bottom: none;">
            <div class="col-md-1">
                <div class="row bottomBorder ">
                    <div class="col">
                        <div class="stat_single_icon">
                            <!-- <img src="../assets/img/LTBI.png"> -->
                            <h6 class="mt-2 text-center">TPT PATHWAY</h6>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="stat_single_icon">
                            <!-- <img src="../assets/img/LTBI.png"> -->
                            <h6 class="mt-2 text-center">TB PATHWAY</h6>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="stat_single">
                    <div class="icon_title">
                        Registered
                        <i v-b-tooltip.hover title="Total number of clients registered in the application" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase" style="height: 85px;">
                        <div class="stat ">
                            <div class="num indexCaseReg" style="font-size: 40px;">{{indicatorObj['TB Pathway : Registered']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2">
                <div class="stat_single">
                    <div class="icon_title">
                        Screened
                        <i v-b-tooltip.hover title="Total number of clients screened for TB symptoms" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase" style="height: 85px;">
                        <div class="stat ">
                            <div class="num indexCaseReg" style="font-size: 40px;"> {{indicatorObj['TPT Pathway : Screened'] + indicatorObj['TB Pathway : Screened']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="row bottomBorder no-gutters">
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title">
                                Referred
                                <i v-b-tooltip.hover title="Total number of clients referred for evaluation/testing for TB infection" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Referred']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title">
                                Tested
                                <i v-b-tooltip.hover title="Total number of clients completing evaluation/testing for TB infection" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Tested']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title">
                                Tested Positive
                                <i v-b-tooltip.hover title="Total number of clients evaluated/tested for TB infection found positive/eligible for TPT" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Tested Positive']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title">
                                TPT Started
                                <i v-b-tooltip.hover title="Total number of clients started TPT" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : TPT initiated']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row  no-gutters">
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title tbBgColor">
                                Referred
                                <i v-b-tooltip.hover title="Total no. of Clients  referred for TB Testing" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Referred']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title tbBgColor">
                                Tested
                                <i v-b-tooltip.hover title="Total number of clients who completed test for TB disease" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Tested']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title tbBgColor">
                                Tested Positive
                                <i v-b-tooltip.hover title="Total number of clients who had positive test for TB disease" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Tested Positive']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="stat_single">
                            <div class="icon_title tbBgColor">
                                TB Started
                                <i v-b-tooltip.hover title="Total number of clients started TB treatment" class=" ml-1 fas fa-info-circle" />
                            </div>
                            <div class="stat_text" id="indexCase">
                                <div class="stat ">
                                    <div class="num indexCaseReg">{{indicatorObj['TB Pathway : TPT initiated']}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- New row end -->
        <div class="row bottomBorder no-gutters hide">
            <div class="col-md-1">
                <div class="stat_single_icon">
                    <!-- <img src="../assets/img/LTBI.png"> -->
                    <h6 class="mt-2 text-center">TPT PATHWAY</h6>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Registered
                        <i v-b-tooltip.hover title="Total number of clients registered in the application" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Registered']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Screened
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TB/LTBI symptoms by ORW" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Screened']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Referred
                        <i v-b-tooltip.hover title="Total no. of clients that were referred for TB infection Testing by ORW" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Referred']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Tested
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TPT symptoms by ORW and Testing was conducted at the Facility" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Tested']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Tested Positive
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TPT symptoms by ORW and Testing was conducted at the Facility and were tested positive" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : Tested Positive']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        TPT Initiated
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TPT symptoms by ORW and Testing was conducted at the Facility and were tested positive. TPT was initiated" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TPT Pathway : TPT initiated']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row bottomBorder no-gutters hide">
            <div class="col-md-1">
                <div class="stat_single_icon">
                    <!-- <img src="../assets/img/LTBI.png"> -->
                    <h6 class="mt-2 text-center">TB PATHWAY</h6>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Registered
                        <i v-b-tooltip.hover title="Total number of clients registered in the application" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Registered']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Screened
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TB/LTBI symptoms" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Screened']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Referred
                        <i v-b-tooltip.hover title="Total no. of Clients that were referred for TB Testing" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Referred']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Tested
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TB symptoms and TB Testing was conducted at the Facility" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Tested']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        Tested Positive
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TB symptoms and TB Testing was conducted at the Facility. and were Tested Positive" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : Tested Positive']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="stat_single">
                    <div class="icon_title">
                        TB Initiated
                        <i v-b-tooltip.hover title="Total no. of Clients that were screened for TB symptoms and TB Testing was conducted at the Facility. and were Tested Positive.TB Treatment was initiated" class=" ml-1 fas fa-info-circle" />
                    </div>
                    <div class="stat_text" id="indexCase">
                        <div class="stat ">
                            <div class="num indexCaseReg">{{indicatorObj['TB Pathway : TPT initiated']}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="content-grid">
        <div class="row align-items-stretch no-gutters">
            <div class="col-lg-6">
                <div class="card map_card">
                    <div class="card-header">
                        <img src="../assets/img/hotspot_map.png">
                        <span>{{ $t("Overview.hotspotdetails") }}</span>
                    </div>
                    <div class="card-body" id="myMap" style="z-index: 0;"></div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card map_card">
                    <div class="card-header chartFilter">
                        <select @change="createCharts()" v-model="chartFilterValue" class="toUpper">
                            <option value="tb_dashboard_counts">TB</option>
                            <option value="tbi_dashboard_counts">TBI</option>
                        </select>
                    </div>
                    <div class="">
                        <highcharts :options="dummyChart1" />
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-center">TB Cases by Age</div>
                    <div class="">
                        <highcharts :options="dummyChart2" />
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-center">TB Cases by Gender</div>
                    <div class="">
                        <highcharts :options="dummyChart3" />
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-center">TBI Cases by Age</div>
                    <div class="">
                        <highcharts :options="dummyChart4" />
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg-3">
                <div class="card">
                    <div class="card-header d-flex justify-content-center">TBI Cases by Gender</div>
                    <div class="">
                        <highcharts :options="dummyChart5" />
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Acceptability of screening']}}%</span>
                            <div class="slice">
                                <div class="bar" :style="btnStyles(10)"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Acceptablity of Screening</p>
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Screening positivity rate']}}%</span>
                            <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Screening Positivity rate</p>
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Screening retention rate']}}%</span>
                            <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Screening Retention rate</p>
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Testing positivity rate']}}%</span>
                            <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Testing Positivity Rate</p>
                    </div>
                </div>
            </div>
            <div v-show="showFlag" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Linkage to care']}}%</span>
                            <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Linkage to Care</p>
                    </div>
                </div>
            </div>
            <div v-show="false" class="col-lg bg-white">
                <div class="">
                    <p></p>
                    <div class="inner-content text-center">
                        <div class="c100  big center">
                            <span>{{programIdiObj['Number needed to screen']}}%</span>
                            <div class="slice">
                                <div class="bar"></div>
                                <div class="fill"></div>
                            </div>
                        </div>
                        <p style="font-weight: bold;">Number Needed to Screen</p>
                    </div>
                </div>
            </div>

            <div class="col-lg-12 mt-2 d-flex justify-content-center">
                <button @click="showFlag = !showFlag" class="btn btn-sm btn-primary">
                    Show
                    <template v-if="!showFlag"> More</template>
                    <template v-if="showFlag"> Less</template>
                </button>
            </div>
            <!-- Commented charts -->
            <div class="col-lg-6" style="display:none">
                <div class="row no-gutters">
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">LTBI Cascade</div>
                            <div class="card-body" id="ltbiCascade">
                                <highcharts :options="chartOptions" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="card">
                            <div class="card-header">{{ $t("Overview.tbcascade") }}</div>
                            <div class="card-body" id="tbCascade">
                                <highcharts :options="chartOptions2" />
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-lg-6">
                        <div class="card">
                            <div class="card-header">Testing/Evaluation Overview</div>
                            <div class="card-body" id="testingOverview"></div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="card">
                            <div class="card-header">Treatment Overview</div>
                            <div class="card-body" id="testingOverview2"></div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <b-modal size="md" id="modal-subindi" hide-footer>
        <template v-slot:modal-title> {{subIndicatorName}} </template>
        <template v-slot:default>
            <div class="stat_single">
                <div class="icon_title">
                    {{subIndicatorName}}
                </div>
                <div class="stat_text" id="indexCase">
                    <div class="stat ">
                        <div class="num indexCaseReg">{{subIndicator1}}</div>
                        <div class="title">
                            <5 years </div> </div> <div class="stat stat_right">
                                <div class="num contactCaseScrened">{{subIndicator2}}</div>
                                <div class="title"> ≥5 years </div>
                        </div>
                    </div>
                </div>
        </template>
    </b-modal>
</div>
</template>

<script>
import ApiServices from '../service/ApiServices'
import INDData from '../assets/IND.json'
import markerUrl from './marker.png'
import JQuery from 'jquery'
let $ = JQuery

export default {
    name: "home",
    components: {},
    // computed: {
    //     btnStyles(rad) {
    //     return {
    //         '-webkit-transform': `rotate(${rad}  + deg)`,
    //         '-moz-transform': `rotate(${rad}  + deg)`,
    //         '-ms-transform': `rotate(${rad}  + deg)`,
    //         '-o-transform': `rotate(${rad}  + deg)`,
    //         'transform': `rotate(${rad}  + deg)`,
    //     };
    //     }
    // },
    data() {
        return {
            // HardCoding variables
            chartFilterValue: 'tb_dashboard_counts',
            showFlag: false,
            periodType: '',
            typeOfClient: '',
            metaIndicatorData: {
                "All": {
                    "TPT": {
                        "Registered": 1000,
                        "Screened": 1000,
                        "Referred": 700,
                        "Tested": 500,
                        "Tested Positive": 468,
                        "TPT Initiated": 450
                    },
                    "TB": {
                        "Registered": 1000,
                        "Screened": 1000,
                        "Referred": 300,
                        "Tested": 297,
                        "Tested Positive": 280,
                        "TB Treatment Initiated": 254
                    }
                },
                "Contacts": {
                    "TPT": {
                        "Registered": 200,
                        "Screened": 200,
                        "Referred": 190,
                        "Tested": 70,
                        "Tested Positive": 66,
                        "TPT Initiated": 65
                    },
                    "TB": {
                        "Registered": 200,
                        "Screened": 200,
                        "Referred": 10,
                        "Tested": 8,
                        "Tested Positive": 5,
                        "TB Treatment Initiated": 5
                    }
                },
                "HIV": {
                    "TPT": {
                        "Registered": 150,
                        "Screened": 150,
                        "Referred": 110,
                        "Tested": 50,
                        "Tested Positive": 48,
                        "TPT Initiated": 40
                    },
                    "TB": {
                        "Registered": 150,
                        "Screened": 150,
                        "Referred": 40,
                        "Tested": 38,
                        "Tested Positive": 32,
                        "TB Treatment Initiated": 30
                    }
                },
                "Others": {
                    "TPT": {
                        "Registered": 650,
                        "Screened": 650,
                        "Referred": 400,
                        "Tested": 380,
                        "Tested Positive": 268,
                        "TPT Initiated": 250
                    },
                    "TB": {
                        "Registered": 650,
                        "Screened": 650,
                        "Referred": 250,
                        "Tested": 190,
                        "Tested Positive": 150,
                        "TB Treatment Initiated": 145
                    }
                }
            },
            indicatorObj: {
                "TB Pathway : Registered": 0,
                "TB Pathway : Screened": 0,
                "TB Pathway : Referred": 0,
                "TB Pathway : TPT initiated": 0,
                "TB Pathway : Tested": 0,
                "TB Pathway : Tested Positive": 0,
                "TPT Pathway : TPT initiated": 0,
                "TPT Pathway : Tested": 0,
                "TPT Pathway : Referred": 0,
                "TPT Pathway : Tested Positive": 0,
                "TPT Pathway : Registered": 0,
                "TPT Pathway : Screened": 0
            },
            programIdiObj: {
                "Number needed to screen": 0,
                "Testing positivity rate": 0,
                "Acceptability of screening": 0,
                "Screening retention rate": 0,
                "Linkage to care": 0,
                "Screening positivity rate": 0
            },
            // 
            inddata: INDData,
            ageGroup: '',
            subIndicatorName: '',
            subIndicator1: '',
            subIndicator2: '',
            // Variable  for map 
            map: null,
            tileLayer: null,
            alllocations: [],
            //
            indexCaseTarget: '500',
            indexCaseReg: '0',
            contactCaseScrened: '0',
            contactCaseTested: '0',
            tb_Tested: '0',
            tbPositive: '0',
            ltbiTested: '0',
            ltbiPositive: '0',
            tbTretInit: '0',
            tbTretNonInt: '0',
            ltbiInit: '0',
            ltbiNonInt: '0',
            ltbiComplete: '0',
            ltbiDiscon: '0',
            contactCaseTestedLtbi: '0',
            ltbirefered: '0',
            userData: JSON.parse(sessionStorage.getItem('userData')),
            chartOptions: {
                chart: {
                    height: 200,
                    type: "column",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    showInLegend: false,
                    data: []
                }]
            },
            chartOptions2: {
                chart: {
                    height: 200,
                    type: "column",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    showInLegend: false,
                    data: []
                }]
            },
            // Dummy Chart
            dummyChart1: {
                chart: {
                    height: 620,
                    type: 'columnrange',
                    inverted: true
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    categories: [],
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    },
                    columnrange: {
                        dataLabels: {
                            // enabled: true,
                        }
                    }
                },
                colors:['#4dcdc1'],
                credits: {
                    enabled: false
                },
                series: [{
                    showInLegend: false,
                    data: [
                        // [-5000, 5000],
                        // [-4000, 4000],
                        // [-3000, 3000],
                        // [-1000, 1000],
                        // [-50, 50],
                    ]
                }]
            },
            dummyChart2: {
                chart: {
                    height: 250,
                    type: "pie",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                colors: ['#008AC5', '#FFED00', '#64A12D'],
                series: [{
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        format: '{point.label}'
                    },
                    keys: ['name', 'y', 'color', 'label'],
                    data: [],
                }]
            },
            dummyChart3: {
                chart: {
                    height: 250,
                    type: "pie",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                colors: ['#008AC5', '#FFED00', '#64A12D'],
                series: [{
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        format: '{point.label}'
                    },
                    keys: ['name', 'y', 'color', 'label'],
                    data: [],
                }]
            },
            dummyChart4: {
                chart: {
                    height: 250,
                    type: "pie",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                colors: ['#008AC5', '#FFED00', '#64A12D'],
                series: [{
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        format: '{point.label}'
                    },
                    keys: ['name', 'y', 'color', 'label'],
                    data: [],
                }]
            },
            dummyChart5: {
                chart: {
                    height: 250,
                    type: "pie",
                    // style: {
                    //     fontFamily: "'Nunito Sans', sans-serif"
                    // }
                },
                title: {
                    text: ""
                },
                subtitle: {
                    text: ""
                },
                xAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        rotation: 0
                    }
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "",
                        align: "high"
                    },
                    labels: {
                        overflow: "justify"
                    }
                },
                tooltip: {
                    valueSuffix: ""
                },
                plotOptions: {
                    bar: {
                        dataLabels: {
                            enabled: true
                        }
                    }
                },
                credits: {
                    enabled: false
                },
                colors: ['#008AC5', '#FFED00', '#64A12D'],
                series: [{
                    showInLegend: true,
                    dataLabels: {
                        enabled: false,
                        format: '{point.label}'
                    },
                    keys: ['name', 'y', 'color', 'label'],
                    data: [],
                }]
            },
            // Variable for filters
            countryList: {},
            countryFlag: true,
            stateList: [],
            stateId: '',
            stateFlag: true,
            districtList: [],
            distId: '',
            distFlag: true,
            facilityList: [],
            filterOrgid: '',
            value1: '',
            fromDate: '',
            toDate: '',
            tiles: '',
            // New Variable for custom prevent TB
            TbObject: {}
        }
    },
    methods: {
        btnStyles(rad) {
            return {
                '-webkit-transform': `rotate(${rad}  + deg)`,
                '-moz-transform': `rotate(${rad}  + deg)`,
                '-ms-transform': `rotate(${rad}  + deg)`,
                '-o-transform': `rotate(${rad}  + deg)`,
                'transform': `rotate(${rad}  + deg) !important`,
            };
        },
        btnStyles2() {
            return {
                'position': 'absolute',
                'border': '0.08em solid #307bbb',
                'width': '0.84em',
                'height': '0.84em',
                'clip': 'rect(0em, 0.5em, 1em, 0em)'
            }
        },
        getDate() {
            console.log(this.value1)
            if (this.periodType == 'Daily') {
                this.fromDate = this.value1[0]
                this.toDate = this.value1[1]
            } else {
                this.fromDate = this.value1 + "-01-01"
                this.toDate = this.value1 + "-12-31"
            }
        },
        // Functions for filter
        getHierarchy(param) {
            this.$root.isLoading = true
            let instance = {
                'orgid': param
            }
            ApiServices.RestGetCall('organisationUnits/' + param + '?paging=false&fields=*,children[id,name]').then(res => {
                console.log(res,"orgdata")
                if (res.level == '2') {
                    this.countryList = res
                    // console.log(this.countryList, "country")
                    this.stateList = res.children
                    this.$root.isLoading = false
                }
                if (res.level == '3') {
                    this.countryFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.stateList.push(res.data)
                    this.districtList = res.children
                }
                if (res.level == '4') {
                    this.countryFlag = false
                    this.stateFlag = false
                    // this.distId = JSON.stringify(res.id)
                    this.districtList.push(res.data)
                }
                // if(res.data.level == '6'){
                //     this.countryFlag = false
                //     this.stateFlag = false
                //     this.distFlag = false
                // }
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        },
        provinceSelect(event) {
            let stateId = event.target.value;
            this.filterOrgid = stateId
            let instance = {
                'orgid': stateId
            }
            ApiServices.RestGetCall('organisationUnits/'+stateId+'?paging=false&fields=*,children[id,name]').then(res => {
                this.distId = ''
                this.districtList = res.children
            })
            // Object.keys(this.stateList).forEach(key => {
            //     if (this.stateList[key].id == stateId) {
            //         this.districtList = this.stateList[key].nodes
            //     }
            // })
        },
        districtChange(event) {
            let distID = event.target.value;
            this.filterOrgid = distID
            let instance = {
                'orgid': distID
            }
            ApiServices.RestGetCall('organisationUnits/'+distID+'?paging=false&fields=*,children[id,name]').then(res => {
                this.facilityList = res.children
            })
            // console.log(this.districtList,distID)
            // Object.keys(this.districtList).forEach(key => {
            //     if (this.districtList[key].id == distID) {
            //         this.facilityList = this.districtList[key].nodes

            //     }
            // })
        },
        cityChange(event) {
            let cityID = event.target.value;
            this.filterOrgid = cityID
        },
        triggerFilter() {
            if (this.filterOrgid == '') {
                this.filterOrgid = this.userData.organisationUnits[0].id
            }
            if (this.userData.programid == '1262097')
                this.getSubIndicator(this.filterOrgid)
            else
                this.getCustomIndicators(this.filterOrgid)
            // this.getIndicators(this.filterOrgid)
            this.getCustomCharts(this.filterOrgid)
            this.getMetaIndicatorData(this.filterOrgid)
            this.initRealTimeGoogleMaps(this.filterOrgid)
        },
        // Filter function END
        getSubIndicator(param) {
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orguid": param,
                "role": this.userData.userrole,
                "language": "en",
                "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate,
                // "agerange": "5",
            }
            if (this.ageGroup != '') {
                instance['agerange'] = "5"
            } else {
                this.getCustomIndicators(param)
                // this.getIndicators(param)
                return
            }
            ApiServices.RestPostCall('rtmpro/customindicator/getdashindicator/agewise',     ).then(res => {
                console.log(res)
                this.$root.isLoading = false

                if (this.ageGroup == '<') {
                    this.indexCaseReg = res.data["Index Case Registration"]["age<=5"]['index']
                    this.contactCaseScrened = res.data['Contact Cases Screening']["age<=5"]['Contact'] + res.data['Contact Cases Screening']["age<=5"]['index']
                    // this.contactCaseTested = res.data['Contact Cases Testing']
                    this.tb_Tested = res.data['TB Contact Cases Testing']["age<=5"]['Contact'] + res.data['TB Contact Cases Testing']["age<=5"]['index']
                    this.tbPositive = res.data['TB Positive']["age<=5"]['Contact'] + res.data['TB Positive']["age<=5"]['index']
                    this.ltbiTested = res.data['LTBI Contact Cases Testing']["age<=5"]['Contact'] + res.data['LTBI Contact Cases Testing']["age<=5"]['index']
                    this.ltbiPositive = res.data['LTBI Postive']["age<=5"]['Contact'] + res.data['LTBI Postive']["age<=5"]['index']
                    this.tbTretInit = res.data['TB Treatment Initiation']["age<=5"]['Contact'] + res.data['TB Treatment Initiation']["age<=5"]['index']
                    this.tbTretNonInt = parseInt(res.data['TB Positive']["age<=5"]['Contact'] + res.data['TB Positive']["age<=5"]['index']) -
                        parseInt(res.data['TB Treatment Initiation']["age<=5"]['Contact'] + res.data['TB Treatment Initiation']["age<=5"]['index'])
                    this.ltbiInit = res.data['LTBI Treatment Initiation']["age<=5"]['Contact'] + res.data['LTBI Treatment Initiation']["age<=5"]['index']
                    this.ltbiNonInt = parseInt(res.data['LTBI Postive']["age<=5"]['Contact'] + res.data['LTBI Postive']["age<=5"]['index']) -
                        parseInt(res.data['LTBI Treatment Initiation']["age<=5"]['Contact'] + res.data['LTBI Treatment Initiation']["age<=5"]['index'])
                    // this.ltbiComplete = res.data['LTBI Treatment OutCome']["age<=5"]['Contact'] + res.data['LTBI Treatment OutCome']["age<=5"]['index']
                    this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']["age<=5"]['Contact'] + res.data['Referred Contact For LTBI']["age<=5"]['index']
                    this.ltbirefered = res.data['Referred Contact For TB']["age<=5"]['Contact'] + res.data['Referred Contact For TB']["age<=5"]['index']
                } else {
                    this.indexCaseReg = res.data["Index Case Registration"]["age>5"]['index']
                    this.contactCaseScrened = res.data['Contact Cases Screening']["age>5"]['Contact'] + res.data['Contact Cases Screening']["age>5"]['index']
                    // this.contactCaseTested = res.data['Contact Cases Testing']
                    this.tb_Tested = res.data['TB Contact Cases Testing']["age>5"]['Contact'] + res.data['TB Contact Cases Testing']["age>5"]['index']
                    this.tbPositive = res.data['TB Positive']["age>5"]['Contact'] + res.data['TB Positive']["age>5"]['index']
                    this.ltbiTested = res.data['LTBI Contact Cases Testing']["age>5"]['Contact'] + res.data['LTBI Contact Cases Testing']["age>5"]['index']
                    this.ltbiPositive = res.data['LTBI Postive']["age>5"]['Contact'] + res.data['LTBI Postive']["age>5"]['index']
                    this.tbTretInit = res.data['TB Treatment Initiation']["age>5"]['Contact'] + res.data['TB Treatment Initiation']["age>5"]['index']
                    this.tbTretNonInt = parseInt(res.data['TB Positive']["age>5"]['Contact'] + res.data['TB Positive']["age>5"]['index']) -
                        parseInt(res.data['TB Treatment Initiation']["age>5"]['Contact'] + res.data['TB Treatment Initiation']["age>5"]['index'])
                    this.ltbiInit = res.data['LTBI Treatment Initiation']["age>5"]['Contact'] + res.data['LTBI Treatment Initiation']["age>5"]['index']
                    this.ltbiNonInt = parseInt(res.data['LTBI Postive']["age>5"]['Contact'] + res.data['LTBI Postive']["age>5"]['index']) -
                        parseInt(res.data['LTBI Treatment Initiation']["age>5"]['Contact'] + res.data['LTBI Treatment Initiation']["age>5"]['index'])
                    // this.ltbiComplete = res.data['LTBI Treatment OutCome']["age>5"]['Contact'] + res.data['LTBI Treatment OutCome']["age>5"]['index']
                    this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']["age>5"]['Contact'] + res.data['Referred Contact For LTBI']["age>5"]['index']
                    this.ltbirefered = res.data['Referred Contact For TB']["age>5"]['Contact'] + res.data['Referred Contact For TB']["age>5"]['index']
                }
            })
        },
        getIndicators(param) {
            //  console.log(this.userData)
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orguid": param,
                "role": this.userData.userrole,
                "language": "en",
                "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate,
                "clienttype": this.typeOfClient
            }
            ApiServices.RestPostCall('rtmpro/customindicator/getdashindicator', instance).then(res => {
                // ApiServices.RestPostCall('dashboardIndicator/geindicators/tb_dashboard_box_indicators', instance).then(res => {
                // console.log(res)
                this.indexCaseReg = res.data["Index Case Registration"]
                this.contactCaseScrened = res.data['Contact Cases Screening']
                // this.contactCaseTested = res.data['Contact Cases Testing']
                this.tb_Tested = res.data['TB Contact Cases Testing']
                this.tbPositive = res.data['TB Positive']
                this.ltbiTested = res.data['LTBI Contact Cases Testing']
                this.ltbiPositive = res.data['LTBI Postive']
                this.tbTretInit = res.data['TB Treatment Initiation']
                this.tbTretNonInt = parseInt(res.data['TB Positive']) - parseInt(res.data['TB Treatment Initiation'])
                this.ltbiInit = res.data['LTBI Treatment Initiation'] || parseInt(res.data['TB preventive treatment'])
                this.ltbiNonInt = parseInt(res.data['LTBI Postive']) - (parseInt(res.data['LTBI Treatment Initiation']) || parseInt(res.data['TB preventive treatment']))
                // this.ltbiComplete = res.data['LTBI Treatment OutCome']
                this.contactCaseTestedLtbi = res.data['Referred Contact For LTBI']
                this.ltbirefered = res.data['Referred Contact For TB']
                var category1 = []
                var data1 = []
                var category = []
                var data = []
                Object.keys(res.data).forEach(key => {
                    if (key == 'TB Contact Cases Testing') {
                        category.push('Contacts tested for TB');
                        data.push(parseInt(res.data['TB Contact Cases Testing']));
                    }
                    if (key == 'TB Positive') {
                        category.push('TB Positive');
                        data.push(parseInt(res.data['TB Positive']));
                    }
                    // B
                    if (key == 'Contact Cases Screening') {
                        category.push('Contacts Registered');
                        data.push(parseInt(res.data['Contact Cases Screening']));
                    }
                    if (key == 'TB Treatment Initiation') {
                        category.push('TB Treatment Initiation');
                        data.push(parseInt(res.data['TB Treatment Initiation']));
                    }
                    //for ltbi
                    if (key == 'LTBI Contact Cases Testing') {
                        category1.push('Contacts tested for TBI');
                        data1.push(parseInt(res.data['LTBI Contact Cases Testing']));
                    }
                    if (key == 'LTBI Postive') {
                        category1.push('TBI Positive');
                        data1.push(parseInt(res.data['LTBI Postive']));
                    }
                    // B
                    if (key == 'Contact Cases Screening') {
                        category1.push('Contacts Registered');
                        data1.push(parseInt(res.data['Contact Cases Screening']));
                    }
                    if (key == 'LTBI Treatment Initiation') {
                        category1.push('TBI Treatment Initiation');
                        data1.push(parseInt(res.data['LTBI Treatment Initiation']));
                    }
                    if (key == 'TB preventive treatment') {
                        category1.push('TBI Treatment Initiation');
                        data1.push(parseInt(res.data['TB preventive treatment']));
                    }
                })
                this.chartOptions.xAxis.categories = category1
                this.chartOptions.series[0].data = data1
                this.chartOptions2.xAxis.categories = category
                this.chartOptions2.series[0].data = data
                this.$root.isLoading = false
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        },
        getCustomIndicators(param) {
            this.$root.isLoading = true
            var instance = {
                "programid": this.userData.programid,
                "orguid": param,
                "role": this.userData.userrole,
                "language": "en",
                "fromdate": this.fromDate,
                "todate": this.toDate,
                "clienttype": this.typeOfClient
            }
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tb_dashboard_box_indicators', instance).then(res => {
                res.data.map(el => {
                    this.indicatorObj[el['indicatorname']] = el['count']
                })
                this.$root.isLoading = false
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tpt_dashboard_box_indicators', instance).then(res => {
                res.data.map(el => {
                    this.indicatorObj[el['indicatorname']] = el['count']
                })
                this.$root.isLoading = false
            })
            // console.log(this.indicatorObj)
        },
        getCustomCharts(param) {
            var instance = {
                "programid": this.userData.programid,
                "orguid": param,
                // "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate,
                "clienttype": this.typeOfClient
            }
            console.log(">>>>>>>orgid" ,param,this.userData.orguid)
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tb_cases_by_age', instance).then(res => {
                this.dummyChart2.series[0].data = []
                res.data.map(el => {
                    let t = []
                    t.push( el['age_group'] == '5<' ? '<5':el['age_group'])
                    t.push(el['count'])
                    this.dummyChart2.series[0].data.push(t)
                })
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tb_cases_by_gender', instance).then(res => {
                this.dummyChart3.series[0].data = []
                res.data.map(el => {
                    let t = []
                    t.push(el['gender'])
                    t.push(el['count'])
                    this.dummyChart3.series[0].data.push(t)
                })
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tbi_cases_by_age', instance).then(res => {
                this.dummyChart4.series[0].data = []
                res.data.map(el => {
                    let t = []
                    t.push( el['age_group'] == '5<' ? '<5':el['age_group'])
                    t.push(el['count'])
                    this.dummyChart4.series[0].data.push(t)
                })
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/tbi_cases_by_gender', instance).then(res => {
                this.dummyChart5.series[0].data = []
                res.data.map(el => {
                    let t = []
                    t.push(el['gender'])
                    t.push(el['count'])
                    this.dummyChart5.series[0].data.push(t)
                })
            })
            ApiServices.RestPostCall('dashboardIndicator/geindicators/performance_charts', instance).then(res => {
                res.data.map(el => {
                    this.programIdiObj[el['indicatorname']] = (el['count'] * 100).toFixed(1)
                })
            })
            this.createCharts()
            // console.log(this.programIdiObj)
        },
        getMetaIndicatorData() {

        },
        createCharts() {
            if (this.filterOrgid == '') {
                this.filterOrgid = this.userData.organisationUnits[0].id
            }
            console.log("orgid>>>>>>>>",this.filterOrgid)
            var instance = {
                "programid": this.userData.programid,
                "orguid": this.filterOrgid,
                // "orguid": this.userData.orguid,
                "fromdate": this.fromDate,
                "todate": this.toDate,
                "clienttype": this.typeOfClient
            }
            var cat = [
                'Contacts Eligible for TB screening',
                'Contacts Screened for TB',
                'Contacts with presumptive TB identified',
                'Contacts evaluated for TB',
                'Contacts diagnosed for TB',
                'Number of people initiated on TB treatment'
            ]
            var cat2 = [
                'Contacts registered',
                'Contacts eligible for TBI testing',
                'Contacts evaluated for TBI',
                'Contacts diagnosed with TBI',
                'Contacts initiated on TPT'
            ]
            ApiServices.RestPostCall('dashboardIndicator/geindicators/' + this.chartFilterValue, instance).then(res => {
                if (this.chartFilterValue == 'tb_dashboard_counts') {
                    this.dummyChart1.series[0].data = []
                    this.dummyChart1.series[0].data.push([-res.data[0]['Number of people eligible for TB sreening'], res.data[0]['Number of people eligible for TB sreening']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Number of people screened for TB'], res.data[0]['Number of people screened for TB']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Number of people with presumptive TB identified'], res.data[0]['Number of people with presumptive TB identified']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Number of people evaluated for TB disease'], res.data[0]['Number of people evaluated for TB disease']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Number of people diagnosed with TB'], res.data[0]['Number of people diagnosed with TB']])
                    this.dummyChart1.xAxis.categories = cat
                    this.dummyChart1.colors = ['#4dcdc1']
                }else{
                    this.dummyChart1.series[0].data = []
                    this.dummyChart1.series[0].data.push([-res.data[0]['Contacts registered'], res.data[0]['Contacts registered']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Contacts eligible for TBI testing'], res.data[0]['Contacts eligible for TBI testing']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Contacts evaluated for TBI'], res.data[0]['Contacts evaluated for TBI']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Contacts diagnosed with TBI'], res.data[0]['Contacts diagnosed with TBI']])
                    this.dummyChart1.series[0].data.push([-res.data[0]['Contacts initiated on TPT'], res.data[0]['Contacts initiated on TPT']])
                    this.dummyChart1.xAxis.categories = cat2
                    this.dummyChart1.colors = ['#238cbb']
                }
            })
        },
        initMap() {
            // this.map = new L.map('myMap').setView([12.8797, 121.7740], 8);
            // this.tileLayer = new L.tileLayer(
            //     'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
            //         maxZoom: 18,
            //         attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
            //     }
            // )
            // this.tileLayer.addTo(this.map)
            let self = this
            this.map = new L.map('myMap').setView([12.8797, 121.7740], 6);
            this.tileLayer = new L.tileLayer(
                'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
                    maxZoom: 18,
                    attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
                }
            )
            this.tileLayer.addTo(this.map)
            // this.tiles =
            // new L.tileLayer(
            //     'https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager/{z}/{x}/{y}.png', {
            //         maxZoom: 18,
            //         attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>, &copy; <a href="https://carto.com/attribution">CARTO</a>',
            //     }
            // )
            // this.tileLayer.addTo(this.map)
            //     // L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     //     maxZoom: 18,
            //     //     attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
            //     // });
            // // L.tileLayer('https://tiles.stadiamaps.com/tiles/alidade_smooth/{z}/{x}/{y}{r}.png', {
            // //     maxZoom: 18,
            // //     attribution: '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
            // // });
            // // var layerObj = L.geoJson(this.inddata, {
            // //     style:{
            // //         color: '#000',
            // //         weight: 0.8,
            // //         fillOpacity: 0,
            // //     }
            // //     })
            // var grayscale = L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     maxZoom: 18,
            //     attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
            // });
            // var streets = L.tileLayer('//{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            //     maxZoom: 18,
            //     attribution: '&copy; <a href="//openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ'
            // })
            // this.map = L.map('myMap', {
            //     zoom: 5,
            //     layers: [streets, grayscale]
            // });
            // var baseMaps = {
            //     "Satellite": streets,
            //     "Grayscale": grayscale,
            // };
            // L.control.layers(baseMaps).addTo(this.map);
            // L.control.layers(baseMaps, overlayMaps).addTo(map);
            // this.map.addLayer(layerObj)
            // var marker = new this.L.Marker([17.385044, 78.486671]);
            // marker.addTo(this.map);
        },
        initRealTimeGoogleMaps(alllocations) {
            let self = this
            this.$root.isLoading = true

            // {"language":"en","programid":"U1nNSk2geJh","orguid":"lkaOHazCzow","fromdate":"2021-01-01","todate":"2022-08-09"}
            var instance = {
                "language": "en",
                "programid": this.userData.programid,
                "orguid": this.userData.organisationUnits[0].id,
                // "orguid": this.userData.orguid,
                "role": this.userData.role,
                // "authparam": this.userData.authparam,
                "fromdate": this.fromDate,
                "todate": this.toDate
            }
            ApiServices.RestPostCall('dashboardIndicator/realtimemap', instance).then(res => {
                console.log(res)
                this.$root.isLoading = false
                alllocations = res.data
                $.each(alllocations, function (key, val) {
                    delete val.teiid;
                    delete val.deviceId;
                    delete val.instanceId;
                    delete val.status;
                    delete val.sysUIC;
                });

                var alllatlong = [];
                $.each(alllocations, function (key, val) {
                    var loc = {
                        lat: Number(val.Latitude),
                        lng: Number(val.Longitude)
                    }
                    alllatlong.push(loc);
                });
                if (res.data.length == 0) {
                    alllatlong = [{
                        lat: 0,
                        lng: 0
                    }]
                }
                var bounds = new L.LatLngBounds(alllatlong);
                // var map = L.map('myMap', {
                //     zoom: 5,
                //     layers: [self.tiles]
                // });

                var mcg = L.markerClusterGroup({
                    chunkedLoading: true,
                    //singleMarkerMode: true,
                    spiderfyOnMaxZoom: true
                });
                var myIcon = L.icon({
                    iconUrl: markerUrl,
                    iconSize: [40, 41],
                    iconAnchor: [22, 94],
                    popupAnchor: [-3, -76],
                    // shadowUrl: '../assets/img/marker.png',
                    shadowSize: [68, 95],
                    shadowAnchor: [22, 94]
                });
                // L.marker([50.505, 30.57], { icon: myIcon }).addTo(map);
                for (var i = 0; i < alllocations.length; i++) {
                    var a = alllocations[i];

                    var markerdata = "";
                    $.each(alllocations[i], function (key, val) {
                        if (key == 'UIC' || key == 'Client Type' || key == 'Given Name' || key == 'Age' || key == 'Gender' || key == 'Phone Number' || key == '') {
                            markerdata += "<p class='text-primary capitalise " + key + "'>" + key + ": " + val + "</p>";
                        }
                    })
                    var title = markerdata;
                    if (a['Client Type'] != 'Index') {
                        var marker = L.marker(new L.LatLng(a.Latitude, a.Longitude), {
                            icon: myIcon
                        }, {
                            title: title
                        });
                        marker.bindPopup(title);
                        mcg.addLayer(marker);
                    }
                }
                if (!this.map) {
                    this.initMap()
                }
                this.map.addLayer(mcg);
                this.map.fitBounds(bounds);
                // map.panTo(new L.LatLng(27.5142, -90.4336));
                if (this.userData.programid == '1329111')
                    this.map.setView(new L.LatLng(27.5142, 90.4336), 8);
            }).catch(error => {
                this.$root.isLoading = false
                console.log(error);
                // swal("Request Failed.");
            });
        }
    },
    mounted() {
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        this.toDate = d.getFullYear() + '-' +
            (('' + month).length < 2 ? '0' : '') + month + '-' +
            (('' + day).length < 2 ? '0' : '') + day;
        this.fromDate = '2021-01-01'
        // this.getIndicators(this.userData.orgid)
        this.getCustomIndicators(this.userData.organisationUnits[0].id)
        this.getCustomCharts(this.userData.organisationUnits[0].id)
        this.getMetaIndicatorData(this.userData.organisationUnits[0].id);
        this.getHierarchy(this.userData.organisationUnits[0].id);
        this.initMap()
        // this.getSubIndicator(this.userData.organisationUnits[0].id)
        this.initRealTimeGoogleMaps(this.alllocations)
        // // console.log(res)
        let langLocal = JSON.parse(sessionStorage.getItem('langLocal'))
        for (let lang in langLocal) {
            console.log(lang, langLocal[lang])
            this.$i18n.setLocaleMessage(lang, langLocal[lang])
        }
        // console.log(this.$i18n.locale,this.$root.localLang)
        // this.$i18n.locale = this.$root.localLang
        // self.$i18n.setLocaleMessage(res)
        // self.$router.push('/home')
    }
};
</script>

<style scoped>
.content-grid .card .card-body {
    height: calc(50vh - 49px);
}
</style>
